module.exports = __webpack_public_path__ + "static/media/portrait.dfb5269b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portrait.png
// module id = 330
// module chunks = 0